import * as React from 'react';
import Accordion from 'react-bootstrap/Accordion';
import { Card } from 'react-bootstrap';
import { connect } from 'react-redux';
import {
  INotificationToken,
  INotificationTokenType
} from '../NotificationTemplate/business-objects/common';
import { getAllTokens } from '../NotificationTemplate/redux-objects/actions';
import { GetURIByParts } from '../../services/Utils/StringUtils';
interface INotificationTokenActionProps {
  getAllTokens: (url: string) => void;
}

interface INotificationTokenStateProps {
  tokenTypes: INotificationTokenType[];
  webServiceURL: string;
}

interface INotificationTokensProps
  extends INotificationTokenActionProps,
    INotificationTokenStateProps {}

interface INotificationTokenState {}

enum ServiceEndPoints {
  ReportTokens = 'ReportTokens',
  TokensByType = 'TokensByType'
}

class NotificationTokens extends React.Component<
  INotificationTokensProps,
  INotificationTokenState
> {
  private notificationTemplatesServiceController: string =
    'NotificationTemplate';

  componentWillMount() {
    let uri = GetURIByParts(
      this.props.webServiceURL,
      this.notificationTemplatesServiceController,
      ServiceEndPoints.TokensByType
    );

    this.props.getAllTokens(uri);
  }

  handleDragStart = (e: any) => {
    //console.log('dragstart', e);
    e.currentTarget.style.opacity = '0.4'; // this / e.target is the source node.
    e.dataTransfer.effectAllowed = 'copy';
    e.dataTransfer.setData('tagName', e.currentTarget.innerHTML);
  };

  handleDragEnd = (e: any) => {
    e.currentTarget.style.opacity = '1';
    e.currentTarget.classList.remove('over');
  };

  componentDidMount() {}

  public render() {
    //console.log('tokens', this.props.tokenTypes);
    return (
      <div className="tokenModalDiv sticky-top">
        <h3>Tokens</h3>
        <Accordion defaultActiveKey="0">
          {this.props.tokenTypes &&
            this.props.tokenTypes.map(tokenType => (
              <Card key={tokenType.id.toString()} className="notificationCard">
                <Accordion.Toggle
                  as={Card.Header}
                  eventKey={tokenType.id.toString()}
                  key={tokenType.id.toString()}
                  className="accordianHeader"
                >
                  {tokenType.name}
                </Accordion.Toggle>
                <Accordion.Collapse eventKey={tokenType.id.toString()}>
                  <Card.Body>
                    {tokenType.tokens &&
                      tokenType.tokens.map(x => (
                        <div
                          key={x.id.toString()}
                          draggable
                          className="tag alert alert-info"
                          onDragStart={this.handleDragStart}
                          onDragEnd={this.handleDragEnd}
                        >
                          {x.name}
                        </div>
                      ))}
                  </Card.Body>
                </Accordion.Collapse>
              </Card>
            ))}
        </Accordion>
      </div>
    );
  }
}

const mapStateToProps = (reduxState: any) => {
  return {
    tokenTypes: reduxState.NotificationTemplates.tokenTypes,
    webServiceURL: reduxState.Application.backendURL
  };
};

const mapDispatchToProps = {
  getAllTokens
};

export default connect<
  INotificationTokenStateProps,
  INotificationTokenActionProps
>(
  mapStateToProps,
  mapDispatchToProps
)(NotificationTokens);
